export default __webpack_public_path__ + "static/media/peoplez.60afb471.png";